import { FileExtension, MimeType } from '@sonar-software/sonar-ts-types';

/**
 * Parses the provided file and provides the resulting data string or buffer.
 * @param file Target {@link File} to read.
 * @returns String or {@link ArrayBuffer} data of the file.
 */
export function readDataFromFile(file: File): Promise<string | ArrayBuffer | null> {
	return new Promise((resolve) => {
		const reader = new FileReader();

		reader.addEventListener('load', () => resolve(reader.result));
		reader.readAsDataURL(file);
	});
}

const mimeTypeExtensionMap: Record<MimeType, FileExtension> = {
	[ MimeType.JPEG ]: FileExtension.JPEG,
	[ MimeType.PNG ]: FileExtension.PNG
};

/**
 * Gets the appropriate file extension for the provided mime type.
 * @param mimeType {@link MimeType} to get the extension for.
 * @returns The {@link FileExtension} related to the provided {@link MimeType}.
 */
export function getFileExtensionForMimeType(mimeType: MimeType): FileExtension {
	return mimeTypeExtensionMap[ mimeType ];
}
